import { PayloadAction } from '@reduxjs/toolkit';
import { call, put } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/types';
import { amlbotAPI } from '@/api';
import type {
  AmlTraceRequest,
  AmlTraceListRequest,
  AmlTraceListResponse,
} from '@/api';
import { parseError } from '@/redux/helpers';
import {
  amlTraceActions,
  amlTraceHistoryActions,
  userActions,
} from '@/redux/actions';
import { amlTraceMappers } from '@/redux/mappers';

function* startTrace(action: PayloadAction<AmlTraceRequest>): SagaIterator {
  try {
    const { payload } = action;
    const response = yield call(amlbotAPI.startTrace, payload);
    const { data, balance } = response;

    if (balance !== null && balance !== undefined) {
      yield put(userActions.setBalance(balance));
    }

    yield put(amlTraceHistoryActions.fetchTraceHistory({}));
    yield put(amlTraceActions.addTraceUpdate({ uuid: data.uid, data: '' }));
    yield put(amlTraceActions.setActiveUuid(data.uid || null));
  } catch (error: unknown) {
    const { message } = parseError(error);
    yield put(amlTraceActions.setError(message));
  } finally {
    yield put(amlTraceActions.finishTrace());
  }
}

function* fetchTraceHistory(
  action: PayloadAction<AmlTraceListRequest>,
): SagaIterator {
  try {
    const { payload } = action;
    const response: AmlTraceListResponse = yield call(
      amlbotAPI.tracingHistory,
      payload,
    );
    const data = amlTraceMappers.traceHistory(response);

    const isShowMoreRequest = 'page' in payload;

    if (isShowMoreRequest) {
      yield put(amlTraceHistoryActions.addData(data));
    } else {
      yield put(amlTraceHistoryActions.setData(data));
    }
  } catch (error: unknown) {
    const { message } = parseError(error);
    yield put(amlTraceHistoryActions.setError(message));
  } finally {
    yield put(amlTraceHistoryActions.setLoading(false));
  }
}

function* fetchCurrencies(): SagaIterator {
  try {
    const response = yield call(amlbotAPI.tracerCurrencies, {});
    const currencies = amlTraceMappers.tracerCurrencies(response);
    yield put(amlTraceActions.setCurrencies(currencies));
  } catch (error: unknown) {
    const { message } = parseError(error);
    yield put(amlTraceActions.setError(message));
  } finally {
    yield put(amlTraceActions.setLoading(false));
  }
}

export { startTrace, fetchTraceHistory, fetchCurrencies };
